class GlyphChanger {
    constructor(variants = {}) {
        this.fontFamilies = {
            jyo: variants?.FirstVariant ??  'Jyo Display',
            nineties: variants?.SecondVariant ?? 'Nineties Display',
            lexend: variants?.Default ?? 'Lexend'
        };
        this.lettersOrder = ['O', 'A', 'E', 'R', 'N', 'M', 'X', 'W', 'S', 'C'];
        this.jyoLetters = ['A', 'E', 'R', 'N', 'M', 'X', 'W'];
        this.ninetiesLetters = ['O', 'S', 'E', 'C'];
        this.regex = {
            excludeHTMLTags: /(?<!<[^>]*)\b[a-zA-Z]+\b(?![^<]*>)/g
        };
    }

    applyGlyphChanges(text, renderCallback) {
        return text.replace(this.regex.excludeHTMLTags, (word) => this.processWord(word, renderCallback));
    }

    processWord(word, callback) {
        let changes = 0;
        let firstEHandled = false;
        let lettersChanged = [];

        // Convert word to an array for easy manipulation
        let wordArray = word.split('');

        // Loop over the word and apply changes
        for (let i = 0; i < wordArray.length; i++) {
            let letter = wordArray[i].toUpperCase();
            
            if (i === 0 || !this.lettersOrder.includes(letter)) {
                // Never change the first letter and skip if the letter is not in the specified list
                continue;
            }

            // Ensure changes are more than 2 letters apart
            if (lettersChanged.length > 0 && i - lettersChanged[lettersChanged.length - 1] <= 2) {
                continue;
            }

            let variant;
            if (this.jyoLetters.includes(letter)) {
                variant = firstEHandled && letter === 'E' ? this.fontFamilies.nineties : this.fontFamilies.jyo;
            } else if (this.ninetiesLetters.includes(letter)) {
                variant = this.fontFamilies.nineties;
            }

            if (letter === 'E' && !firstEHandled) {
                firstEHandled = true;
            }

            // wordArray[i] = `<span style="font-family: ${variant};">${wordArray[i]}</span>`;
            if (callback != null && typeof callback === 'function')
                wordArray[i] = callback(wordArray[i], variant);
                lettersChanged.push(i);
                changes++;

            // Implement the rule for 3-8 letter words (single glyph change)
            if (wordArray.length >= 3 && wordArray.length <= 8 && changes === 1) break;

            // Implement the rule for 8+ letter words (two glyph changes)
            if (wordArray.length > 8 && changes === 2) break;
        }

        // Join the array back into a string and return
        return wordArray.join('');
    }
}